import React, { useState, useEffect, useCallback } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import DatePicker from 'react-datepicker'
import TextInput from '../../../components/TextInput'
import dayjs from 'dayjs'

import { req } from '../../../util'
import { toggleLoading, toast } from '../../../redux/actions'

export const PeriodReport = () => {

    const dispatch = useDispatch()
    const [from, setFrom] = useState(new Date())
    const [to, setTo] = useState(new Date())
    const [searchQuery, setSearchQuery] = useState("")
    const [report, setReport] = useState([])


    const getReport = useCallback(async () => {
        let fromDateFormat = dayjs(from || new Date()).format("YYYY-MM-DD")
        let toDateFormat = dayjs(to || new Date()).format("YYYY-MM-DD")
        try {
            dispatch(toggleLoading())
            let { success, data, msg } = await req("GET", `car/report?from=${fromDateFormat}&to=${toDateFormat}`)
            if (success) setReport(data)
            dispatch(toggleLoading())
            if (!success) dispatch(toast({ msg }))
        } catch (err) {
            dispatch(toggleLoading())
            dispatch(toast({ msg: 'لا يمكن الوصول الى الخادم', msgType: 0 }))
        }
    }, [from, to])



    useEffect(() => {
        getReport()
    }, [getReport])


    return (
        <div className="container mx-auto p-2 m-2">
            <div className="text-center font-normal text-lg m-2">تقرير العجلات لفترة معينة</div>
            <div className="mx-auto flex justify-around items-center p-2">
                <div className="w-1/3">
                    <DatePicker selected={from} onChange={date => setFrom(date)} className="bg-gray-200 p-1 w-full" placeholderText="من" />
                </div>
                <div className="w-1/3">
                    <DatePicker selected={to} onChange={d => setTo(d)} className="bg-gray-200 p-1 w-full" placeholderText="الى" />
                </div>
            </div>
            <div className="flex mx-auto items-center justify-center my-2">
                <div className="w-1/2">
                    <TextInput value={searchQuery} onChange={evt => setSearchQuery(evt.target.value)} placeholder="بحث رقم عجلة او اسم زبون" />
                </div>
            </div>
            <div className="w-full mt-2 mx-2">
                <div className="border-2 rounded border-grey-200">
                    <table className="text-left w-full">
                        <thead className="flex text-right font-semibold text-gray-600 w-full ">
                            <tr className="flex text-center w-full bg-grey-050 border-b-2 items-center border-grey-200">
                                <th className="p-2 w-8">ت</th>
                                <th className="p-2 w-3/12">اسم الزبون</th>
                                <th className="p-2 w-2/12">رقم العجلة</th>
                                <th className="p-2 w-2/12">رقم الشاصي</th>
                                <th className="p-2 w-1/12">الماركة</th>
                                <th className="p-2 w-1/12">النوع</th>
                                <th className="p-2 w-2/12">تاريخ الفحص</th>
                            </tr>
                        </thead>
                        <tbody className="flex flex-col items-center text-md text-right w-full overflow-y-scroll h-64" id="feed">
                            {report.filter(el => el.client.includes(searchQuery) || el.plateNo.includes(searchQuery)).map((r, index) => (
                                <tr key={index} className="flex text-center w-full border-b border-grey-50 text-grey-900 cursor-pointer">
                                    <td className="py-2 px-1 w-8 text-center">
                                        <Link to={`/writeReport?id=${r.id}`} target="_blank">{index + 1}</Link>
                                    </td>
                                    <td className="py-2 px-1 w-3/12">
                                        {r.client}
                                    </td>
                                    <td className="py-2 px-1 w-2/12">
                                        {r.plateNo} - {r.plateType}
                                    </td>
                                    <td className="py-2 px-1 w-2/12">
                                        {r.vinNo}
                                    </td>
                                    <td className="py-2 px-1 w-1/12">
                                        {r.brand}
                                    </td>
                                    <td className="py-2 px-1 w-1/12">
                                        {r.model}
                                    </td>
                                    <td className="py-2 px-1 w-2/12">
                                        {dayjs(r.created_at).format("YYYY-MM-DD")}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}
